"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
exports.toImage = void 0;
var utils_1 = require("@lglp/utils");
var number_1 = require("./number");
var text_1 = require("./text");
var toThumb = function (prismicThumb, logger) {
    var url = prismicThumb.url, dimensions = prismicThumb.dimensions, rest = __rest(prismicThumb, ["url", "dimensions"]);
    return utils_1.compact(__assign(__assign({}, rest), { src: logger.required(text_1.toText(url)), width: number_1.toNumber(dimensions === null || dimensions === void 0 ? void 0 : dimensions.width), height: number_1.toNumber(dimensions === null || dimensions === void 0 ? void 0 : dimensions.height) }));
};
var thumbs = function (val, logger) {
    var thumbs = utils_1.unprefix('thumb', val);
    if (!thumbs) {
        return undefined;
    }
    return Object.entries(thumbs).reduce(function (acc, _a) {
        var _b;
        var key = _a[0], thumb = _a[1];
        var normalizedThumb = toThumb(thumb, logger);
        if (!thumb) {
            return acc;
        }
        var normalizedThumbKey = key.replace(/[-_][a-z]/g, function (val) { return val[1].toUpperCase(); });
        return __assign(__assign({}, acc), (_b = {}, _b[normalizedThumbKey] = normalizedThumb, _b));
    }, {});
};
var toImage = function (prismicImage, logger) {
    if (!prismicImage) {
        return undefined;
    }
    var url = prismicImage.url, alt = prismicImage.alt, dimensions = prismicImage.dimensions, copyright = prismicImage.copyright, rest = __rest(prismicImage, ["url", "alt", "dimensions", "copyright"]);
    return utils_1.compact({
        src: logger.required(text_1.toText(url)),
        alt: text_1.toText(alt),
        copyright: text_1.toText(copyright),
        thumbnail: thumbs(rest, logger),
        width: number_1.toNumber(dimensions === null || dimensions === void 0 ? void 0 : dimensions.width),
        height: number_1.toNumber(dimensions === null || dimensions === void 0 ? void 0 : dimensions.height)
    });
};
exports.toImage = toImage;
//# sourceMappingURL=image.js.map